/**
 * User activity tracking API
 */

// Get the API URL from environment variables or use a default
const API_BASE_URL = import.meta.env.VITE_API_URI || 'http://localhost:8000';

/**
 * Track user login activity
 * Called after successful Cognito authentication
 * @param token - JWT token for authentication
 * @returns Promise with tracking result
 */
export async function trackUserLogin(token: string): Promise<{
  success: boolean;
  message: string;
  login_count?: number;
  error?: string;
}> {
  try {
    const response = await fetch(`${API_BASE_URL}/activity/track-login`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error tracking user login:', error);
    // Return a non-throwing error response so login doesn't fail
    return {
      success: false,
      message: 'Failed to track login',
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
}
